import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ids", "submit", "paymentLine", "list"]

  remove(event) {
    event.preventDefault()

    const button = event.currentTarget
    const paymentLine = button.closest(".selected-payment-line")
    const paymentId = Number(paymentLine.dataset.paymentId)

    // Update IDs
    const currentIds = this.idsTarget.value.split(" ").filter(s => s.trim().length > 0).map(Number)
    const updatedIds = currentIds.filter(id => id !== paymentId)
    this.idsTarget.value = updatedIds.join(" ")

    // Remove the line
    paymentLine.remove()

    // Update UI
    if (updatedIds.length === 0) {
      if (this.hasListTarget) {
        this.listTarget.innerHTML = ""
      }
    } else {
      this.updateWarnings(updatedIds)
    }

    this.updateSubmitButton(updatedIds)
  }

  updateSubmitButton(ids) {
    if (!this.hasSubmitTarget) return

    this.submitTarget.disabled = ids.length === 0

    // Update hidden input in the submit form if it exists
    const form = this.submitTarget.form || this.submitTarget.closest("form")
    if (form) {
      const input = form.querySelector('input[name="payment_ids"]')
      if (input) {
        input.value = ids.join(" ")
      }
    }
  }

  updateWarnings(ids) {
    if (ids.length === 0) return

    const firstPaymentId = ids[0]
    const firstLine = this.paymentLineTargets.find(
      line => Number(line.dataset.paymentId) === firstPaymentId
    )

    if (firstLine) {
      const warning = firstLine.querySelector(".fa-exclamation-triangle")
      if (warning) warning.remove()
    }
  }
}
